import { render } from "./Location.svg?vue&type=template&id=6625ce55"
const script = {}
script.render = render

export default script